export default __webpack_public_path__ + "static/media/to-the-point.0e3efe32.mp3";